import BaoCaoNgayPage from "./BaoCaoNgayPage";
export default BaoCaoNgayPage